import type { StepUpAction } from "@/hooks/stepUp/stepUpSnapshot";

import { markStepUpReturned } from "@/hooks/stepUp/stepUpSnapshot";

import { safeReturnTo } from "./safeReturnTo";

type RedirectAppState = { returnTo?: unknown; stepUpAction?: StepUpAction };

export const handleAuth0Redirect = (
  appState: RedirectAppState | undefined,
  replace: (to: string) => void,
): void => {
  // Mark before navigating: replace() notifies route subscribers immediately, and a report mounting first would read the snapshot without the marker.
  if (appState?.stepUpAction) markStepUpReturned(appState.stepUpAction);
  replace(safeReturnTo(appState?.returnTo));
};
